<template>
	<div>
		<div>
			<div>
				<div data-v-486d5814="" data-v-30babe2d="" class="my-header">
					<div data-v-486d5814=""
						class="header-row van-row van-row--flex van-row--align-center van-row--justify-space-between">
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-459e9abf="" class="van-dropdown-menu">
								<div class="van-dropdown-menu__bar" @click="lang_open()">
									<div role="button" tabindex="0" class="van-dropdown-menu__item"><span
											class="van-dropdown-menu__title" style="">
											<div class="van-ellipsis" id="lang_text">{{xz_lang}}</div>
										</span></div>
								</div>
								<div data-v-459e9abf="">
									<div class="van-dropdown-item van-dropdown-item--down" style="top: 48.9531px;;"
										id="lang_div" v-show="lang_div">
										<div class="van-overlay"
											style="z-index: 2003; position: absolute; animation-duration: 0.2s; display: ;"
											@click="lang_open()">
										</div>
										<div class="van-popup van-popup--top van-dropdown-item__content"
											style="transition-duration: 0.2s; z-index: 2004; display: ;">

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option" style=""
												@click="change('en','English')">
												<div class="van-cell__title"><span>English</span></div>
											</div>

											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('tu','Türkçe')">
													<span>Türkçe</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('po','Português')">
													<span>Português</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('al','عربي')">
													<span>عربي</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('de','Deutsch')">
													<span>Deutsch</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('xi','español')">
													<span>español</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('yi','Italiano')">
													<span>Italiano</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('el','Русский')">
													<span>Русский</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option">
												<div class="van-cell__title" @click="change('ja','日本')">
													<span>日本</span>
												</div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option"
												@click="change('zh','简体中文')">
												<div class="van-cell__title"><span>简体中文</span></div>
											</div>
											<div role="button" tabindex="0"
												class="van-cell van-cell--clickable van-dropdown-item__option "
												@click="change('fa','繁体中文')">
												<div class="van-cell__title"><span>繁体中文</span></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8">
							<div data-v-486d5814="" class="flex align-center justify-center">
								<h2 data-v-486d5814="" class="plat-name">Pool</h2>
							</div>
						</div>
						<div data-v-486d5814="" class="van-col van-col--8" style="text-align: right; padding-right: 10px;">
							<button data-v-486d5814="" disabled="disabled"
								class="van-button van-button--default van-button--mini van-button--plain van-button--disabled van-button--hairline van-hairline--surround"
								style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
								<div data-v-486d5814="" class="van-button__content"><img :src="bi_img" style="width: 20px;height: 20px;"/><span data-v-486d5814=""
										class="van-button__text"
										style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;font-size:10px;margin-left: 10px;">{{selectedAccount}}</span>
								</div>
							</button>
						</div>
					</div>
				</div> <!---->
			</div>
			<div data-v-10b0ab0a="" class="body-center ypage-box">
				<div data-v-10b0ab0a="" class="actions">
					<div class="van-tabs van-tabs--line">
						<div class="van-tabs__wrap">
							<div role="tablist" class="van-tabs__nav van-tabs__nav--line">
								<div role="tab" aria-selected="true" class="van-tab van-tab--active">
									<span class="van-tab__text van-tab__text--ellipsis" @click="qiehuan('1')">{{type}}</span>
								</div>

								<div role="tab" class="van-tab">
									<span class="van-tab__text van-tab__text--ellipsis" @click="qiehuan('2')">
										{{$t('提取')}}</span>
								</div>
								<div class="van-tabs__line" style="left:75px;" v-show="duihuan_div_xia"></div>
								<div class="van-tabs__line" style="left:272px;" v-show="tiqu_div_xia"></div>

							</div>
						</div>

						<div class="van-tabs__content van-tabs__content--animated">
							<div class="van-tabs__track">
								<div role="tabpanel" class="van-tab__pane-wrapper " v-show="duihuan_div">
									<div class="van-tab__pane">
										<div data-v-10b0ab0a="" class="actions-con box-shadow">
											<div data-v-10b0ab0a="" class="records-btn" @click="tz('/record')"><i
													data-v-10b0ab0a="" class="van-icon van-icon-balance-list-o"
													style="font-size: 16px;"></i> <span data-v-10b0ab0a=""
													class="fs14">{{$t('记录')}}</span></div>
											<h2 data-v-10b0ab0a="" class="h2 black-color">{{$t('兑换')}}
											</h2>
											<div data-v-10b0ab0a="" class="input-wrap">
												<div data-v-10b0ab0a="" class="flex-wrap"><span data-v-10b0ab0a=""
														class="m-r-10 mw-40">从</span>
													<div data-v-10b0ab0a="" class="field">
														<div data-v-10b0ab0a=""
															class="van-cell van-cell--center van-field">
															<div
																class="van-cell__value van-cell__value--alone van-field__value">
																<div class="van-field__body"><input type="text"
																		:placeholder="dtx" class="van-field__control"
																		id="from_zhi" v-on:input="from_zhi_bianhua">
																	<div class="van-field__button"><span
																			data-v-10b0ab0a="" class="link-color fs12"
																			@click="all()">{{$t('全部')}}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div data-v-10b0ab0a="" class="usdt-wrap">
														<img data-v-10b0ab0a="" :src="bi_img" class="usdt-icon">
														<span data-v-10b0ab0a="">{{type}}</span>
													</div>
												</div>
											</div>
											<div data-v-10b0ab0a="" class="speator"><i data-v-10b0ab0a=""
													class="van-icon van-icon-down" style="color: rgb(0, 82, 255);"></i>
											</div>
											<div data-v-10b0ab0a="" class="input-wrap">
												<div data-v-10b0ab0a="" class="flex-wrap"><span data-v-10b0ab0a=""
														class="m-r-10 mw-40">{{$t('至')}}</span>
													<div data-v-10b0ab0a="" class="field">
														<div data-v-10b0ab0a=""
															class="van-cell van-cell--center van-field van-field--disabled">
															<div
																class="van-cell__value van-cell__value--alone van-field__value">
																<div class="van-field__body"><input type="text"
																		disabled="disabled" class="van-field__control"
																		:value="newto_zhi" id="to_zhi"></div>
															</div>
														</div>
													</div>
													<div data-v-10b0ab0a="" class="usdt-wrap"><img data-v-10b0ab0a=""
															src="../../public/img//ustd-logo_78234c021a516747047a450cda026e00.png"
															class="usdt-icon">
														<span data-v-10b0ab0a="">USDT</span>
													</div>
												</div>
											</div>
											<div data-v-10b0ab0a="" class="tr m-t-15 bold fs14"> <span>{{$t('价格')}}</span>:
												1{{type}} ≈
												{{duihuanbili}}USDT
											</div>
										</div>
										<div data-v-10b0ab0a="" class="m-t-20 m-r-10 m-l-10"><button data-v-10b0ab0a=""
												class="exchange-btn van-button van-button--primary van-button--normal van-button--block van-button--round"
												@click='sq_duihuan()'>
												<div data-v-10b0ab0a="" class="van-button__content"><span
														data-v-10b0ab0a="" class="van-button__text"> {{$t('兑换')}}</span></div>
											</button>
											<div data-v-10b0ab0a=""
												style="font-size: 13px; margin: 20px; text-align: left;">
												{{$t('将矿池收益的BNB兑换成USDT后立即到账')}}
											</div>
										</div>
									</div>
								</div>



								<div role="tabpanel" class="van-tab__pane-wrapper" id="div3" v-show="tiqu_div">
									<div class="van-tab__pane">
										<div data-v-10b0ab0a="" class="actions-con box-shadow">
											<div data-v-10b0ab0a="" class="records-btn"><i data-v-10b0ab0a=""
													class="van-icon van-icon-balance-list-o"
													style="font-size: 16px;"></i> <span data-v-10b0ab0a="" class="fs14"
													@click="tz('/record')">{{$t('记录')}}</span>
											</div>
											<h2 data-v-10b0ab0a="" class="h2 black-color">{{$t('提取')}}
											</h2>
											<div data-v-10b0ab0a="" class="input-wrap">
												<div data-v-10b0ab0a="" class="flex-wrap">
													<div data-v-10b0ab0a="" class="field">
														<div data-v-10b0ab0a=""
															class="van-cell van-cell--center van-field">
															<div
																class="van-cell__value van-cell__value--alone van-field__value">
																<div class="van-field__body"><input type="text"
																		:placeholder="zong_u" class="van-field__control"
																		:value="tx_zong_u" id="zong_u">
																	<div class="van-field__button"><span
																			data-v-10b0ab0a="" class="link-color fs12"
																			@click="all_tixian()">{{$t('全部')}}</span></div>
																</div>
															</div>
														</div>
													</div>
													<div data-v-10b0ab0a="" class="usdt-wrap"><img data-v-10b0ab0a=""
															src="../../public/img//ustd-logo_78234c021a516747047a450cda026e00.png"
															class="usdt-icon">
														<span data-v-10b0ab0a="">USDT</span>
													</div>
												</div>
											</div>
										</div>
										<div data-v-10b0ab0a="" class="m-t-20 m-r-10 m-l-10"><button data-v-10b0ab0a=""
												class="exchange-btn van-button van-button--primary van-button--normal van-button--block van-button--round"
												@click="sqtx()">
												<div data-v-10b0ab0a="" class="van-button__content"><span
														data-v-10b0ab0a="" class="van-button__text">{{$t('确认')}} </span></div>
											</button>
											<div data-v-10b0ab0a=""
												style="font-size: 13px; margin: 20px; text-align: left;">
												{{$t('将USDT提取后会在24小时内到达你的钱包')}}

											</div>
										</div>
									</div>
								</div>
							</div>
						</div>



					</div>
				</div>
			</div>
		</div>
		<div>
			<div data-v-2120af5d="" data-v-30babe2d="">
				<div data-v-2120af5d="" class="van-tabbar__placeholder" style="height: 50px;">
					<div class="van-tabbar van-tabbar--fixed">
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('/')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-home-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('首页')}} </div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('pool')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-gem"></i></div>
							<div class="van-tabbar-item__text">{{$t('我的矿池')}} </div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item van-tabbar-item--active">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-paid"></i></div>
							<div class="van-tabbar-item__text">{{$t('提取')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('team')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-friends-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('推荐')}}</div>
						</div>
						<div data-v-2120af5d="" class="van-tabbar-item" @click="tz('account')">
							<div class="van-tabbar-item__icon"><i class="van-icon van-icon-user-o"></i></div>
							<div class="van-tabbar-item__text">{{$t('账户')}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import Web3 from 'web3'
	import axios from 'axios'
	import {
		ethers
	} from 'ethers';
	import {
		useI18n
	} from 'vue-i18n'

	import domain from '../../public/domain';

	import layer from "layui-layer";
	export default {
		name: 'App',
		data() {
			return {
				selectedAccount: '',
				address: '',
				lang_div: false,
				xz_lang: 'English',
				duihuan_div: true,
				tiqu_div: false,
				duihuan_div_xia: true,
				tiqu_div_xia: false,
				duihuanbili: 0,
				type: 'ETH',
				bi_img: '../../img/eth.png',
				dtx: 0,
				newto_zhi: 0,
				user_data: [],
				zong_u: 0,
				tx_zong_u:''
			}
		},

		methods: {
			all_tixian() {
				var zong_u = this.user_data.zong_u
				this.tx_zong_u = zong_u
			},
			all() {
				var duihuanbili = this.duihuanbili
				var dtx = this.user_data.dtx
				document.getElementById('from_zhi').value = dtx;
				var to_zhi = dtx * duihuanbili
				var newto_zhi = Math.floor(to_zhi * 100) / 100
				this.newto_zhi = newto_zhi
			},
			from_zhi_bianhua() {
				var duihuanbili = this.duihuanbili
				var from_zhi = document.getElementById("from_zhi").value;
				var to_zhi = from_zhi * duihuanbili
				var newto_zhi = Math.floor(to_zhi * 100) / 100
				this.newto_zhi = newto_zhi
			},
			feilv() {
				var address = sessionStorage.getItem("address");
				let type = sessionStorage.getItem('type');
				var newtype = '';
				if (type == "ETH") {
					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/feilv?type=" + newtype,
					})
					.then(function(response) {
						console.log(response.data)
						if (response.data.code == 0) {
							console.log(response.data.data)
							im.duihuanbili = response.data.data
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			qiehuan(type) {
				if (type == 1) {
					this.duihuan_div = true
					this.tiqu_div = false
					this.duihuan_div_xia = true
					this.tiqu_div_xia = false
				} else {
					this.duihuan_div = false
					this.tiqu_div = true
					this.duihuan_div_xia = false
					this.tiqu_div_xia = true
				}

			},
			tz(url) {
				window.location.href = '/#' + url
			},
			change(type, name) {

				console.log(this.$i18n.locale)
				this.$i18n.locale = type
				this.lang_div = false
				this.xz_lang = name
				sessionStorage.setItem("lang_type", type);
			},
			lang_open() {
				if (this.lang_div == true) {
					this.lang_div = false
				} else {
					this.lang_div = true
				}
			},
			async wakeUpWallet() {
				this.type = sessionStorage.getItem('bi_type');

				this.bi_img = sessionStorage.getItem('bi_img');

				var address = sessionStorage.getItem("address");
				if (!address) {
					if (window.ethereum) {
						window.ethereum.enable().then((res) => {
							var address = res[0];
							console.log(address)
							this.selectedAccount = address.substr(0, 4) + "..." + address.substr(-4);
							this.address = address;

							sessionStorage.setItem("selectedAccount", this.selectedAccount);
							sessionStorage.setItem("address", this.address);
						})
					} else {
						// 		const web3 = new Web3(window.ethereum)
						await window.ethereum.request({
							method: 'eth_requestAccounts'
						});
						this.web3 = await new Web3(window.ethereum);
						this.connected = true;
						console.log("已连接钱包");
						alert("请安装钱包")
					}
				} else {
					this.selectedAccount = sessionStorage.getItem("selectedAccount");
					this.address = sessionStorage.getItem("address");
				}
				
				
				await window.ethereum.on('chainChanged', (chainId) => {
					// 正确处理链更改之后的业务流程可能很复杂。官方建议链更改只有重新加载页面
					console.log("chainId", chainId)
					window.location.reload();
				});

			},
			get_yue() {
				var address = sessionStorage.getItem("address");
				var type = sessionStorage.getItem("type");
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_yue?type=" + newtype + "&address=" + address
					})
					.then(function(response) {
						if (response.data.data.length !== 0) {
							im.dtx = response.data.data.dtx
							im.user_data = response.data.data
							im.zong_u = response.data.data.zong_u
				
						}

					})
					.catch(function(error) {
						console.log(error);
					});
			},

			sq_duihuan() {
				var address = sessionStorage.getItem("address");
				var type = sessionStorage.getItem("type");
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}

				var lang = this.$i18n.locale


				layer.load(0);
				var ly = layer
				var from_zhi = document.getElementById("from_zhi").value;
				// var to_zhi = document.getElementById("to_zhi").value;
				var to_zhi = this.newto_zhi;

				var im = this
				axios({
						method: 'post',
						url: domain.publicUrl + "/api/api/sq_duihuan",
						data: {
							address: address,
							bi: from_zhi,
							u: to_zhi,
							lang: lang,
							type: newtype
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {


							ly.closeAll()
							ly.msg(response.data.msg)
							setTimeout(function() {
								location.reload();
							}, 3000);
						} else {

							ly.closeAll()
							ly.msg(response.data.msg)
						}

					})
					.catch(function(error) {
						console.log(error);
					});


			},

			sqtx() {
				var address = sessionStorage.getItem("address");
				var type = sessionStorage.getItem("type");
				var newtype = '';
				if (type == "ETH") {

					newtype = 'erc';
				} else {
					newtype = 'bsc';
				}
				var lang = this.$i18n.locale

				layer.load(0);
				var ly = layer
				var price = document.getElementById("zong_u").value;
				var im = this
				axios({
						method: 'post',
						url: domain.publicUrl + "/api/api/sqtx",
						data: {
							address: address,
							price: price,
							lang: lang,
							type:newtype
						},
					})
					.then(function(response) {
						if (response.data.code == 0) {


							ly.closeAll()
							ly.msg(response.data.msg)
							setTimeout(function() {
								location.reload();
							}, 3000);
						} else {

							ly.closeAll()
							ly.msg(response.data.msg)
						}

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			fn() {
				var lang_type = sessionStorage.getItem("lang_type");
				var name = "English"
				if(!lang_type){
					name = "English"
				}else{
					if (lang_type == 'zh') {
						name = '简体中文'
					} else if (lang_type == 'fa') {
						name = '繁体中文'
					} else if (lang_type == 'en') {
						name = 'English'
					} else if (lang_type == 'po') {
						name = 'Português'
					} else if (lang_type == 'al') {
						name = 'عربي'
					} else if (lang_type == 'de') {
						name = 'Deutsch'
					} else if (lang_type == 'xi') {
						name = 'español'
					} else if (lang_type == 'yi') {
						name = 'Italiano'
					} else if (lang_type == 'el') {
						name = 'Русский'
					} else if (lang_type == 'ja') {
						name = '日本語'
					} else if (lang_type == 'tu') {
						name = 'Türkçe'
					}
				}
				
				
				this.xz_lang = name
			},
			

		},
		mounted: function() { //自动触发写入的函数
			this.wakeUpWallet();
			this.feilv();
			this.get_yue();
			let type = this.$route.query.type
			if(type){
				this.qiehuan(2)
			}
			this.fn();
			
		}
	}
</script>


<style>
</style>